var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "objc_class_prefix": "GiftItemInfo",
        "java_package": "com.asiainno.uplive.proto.gift"
    },
    "messages": [
        {
            "name": "GiftItemInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "itemId",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "itemName",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "itemDesc",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "updateTime",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "totalIncome",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "giftAmount",
                    "id": 6
                },
                {
                    "rule": "repeated",
                    "type": "Gift.ItemGiftList.GiftItemGiftList",
                    "name": "giftList",
                    "id": 7
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "gtoIncomes",
                    "id": 8
                }
            ]
        },
        {
            "name": "Gift",
            "fields": [],
            "messages": [
                {
                    "name": "ItemGiftList",
                    "fields": [],
                    "options": {
                        "objc_class_prefix": "GiftItemGiftList",
                        "java_package": "com.asiainno.uplive.proto.gift"
                    },
                    "messages": [
                        {
                            "name": "GiftItemGiftList",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "giftId",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "name",
                                    "id": 2
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "intro",
                                    "id": 3
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "type",
                                    "id": 4
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "url",
                                    "id": 5
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "price",
                                    "id": 6
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "experience",
                                    "id": 7
                                },
                                {
                                    "rule": "optional",
                                    "type": "bool",
                                    "name": "canCombo",
                                    "id": 8
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "version",
                                    "id": 9
                                },
                                {
                                    "rule": "optional",
                                    "type": "bool",
                                    "name": "onLined",
                                    "id": 10
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "countryCode",
                                    "id": 11
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "language",
                                    "id": 12
                                },
                                {
                                    "rule": "optional",
                                    "type": "bool",
                                    "name": "needLoad",
                                    "id": 13
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "showType",
                                    "id": 14
                                },
                                {
                                    "rule": "repeated",
                                    "type": "GiftResourceInfo",
                                    "name": "resources",
                                    "id": 15
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "vipGrade",
                                    "id": 16
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "playTimes",
                                    "id": 17
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "produceType",
                                    "id": 18
                                },
                                {
                                    "rule": "optional",
                                    "type": "bool",
                                    "name": "canSendToAllUsers",
                                    "id": 19
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "timeLimit",
                                    "id": 20
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "hostBill",
                                    "id": 21
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "gtoPrice",
                                    "id": 22
                                }
                            ]
                        },
                        {
                            "name": "GiftResourceInfo",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "type",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "url",
                                    "id": 2
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "md5",
                                    "id": 3
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "json",
                                    "id": 4
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "ItemList",
                    "fields": [],
                    "options": {
                        "objc_class_prefix": "GiftItemList",
                        "java_package": "com.asiainno.uplive.proto.gift"
                    },
                    "messages": [
                        {
                            "name": "Request",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "pageSize",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "pageNum",
                                    "id": 2
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "itemType",
                                    "id": 3
                                }
                            ]
                        },
                        {
                            "name": "Response",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "totalItem",
                                    "id": 1
                                },
                                {
                                    "rule": "repeated",
                                    "type": "GiftItemInfo",
                                    "name": "itemInfos",
                                    "id": 2
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
}).build();
export default _root;



// WEBPACK FOOTER //
// ./js/pb/giftitemlist.pb.js